export default __webpack_public_path__ + "static/media/cat8.0413ffc5.png";